<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h5 class="info-text">Please Approve or reject Muongozo</h5>
        </div>
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout-item md-small-size-100">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-radio v-model="accept" :value="false">Accept</md-radio>
              <md-radio v-model="accept" :value="true">Reject</md-radio>
            </div>

            <md-field>
              <md-input v-model="reason" type="text"></md-input>
              <span class="md-helper-text"
              >If rejected please provide reason</span>
            </md-field>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';


export default {
    data () {
        return {
            accept: true,
            reason: ''
        };
    },
    methods: {
        validate () {
            return this.$refs.form.validate().then(res => {
                if (!res) {
                    return;
                }
                this.$emit('on-validated', res);
                return res;
            });
        }
    }
};
</script>
<style></style>
